import { AiOutlineFolderOpen } from "react-icons/ai";

const FolderOpenIcon = ({ size }) => {
  return <AiOutlineFolderOpen size={size} className="no-shrink" />;
};

export default FolderOpenIcon;
